
import { Image } from "element-ui"
import { getPandoraCoupon } from "@/api/dshop"
import { formatImgUrl } from "@/utils/utils"

export default {
  name: "ImageArea",
  components: {
    [Image.name]: Image
  },
  props: {
    module: Object
  },
  data() {
    return {
      isLoadErr: false
    }
  },
  computed: {
    imgBgColor() {
      return this.module?.data?.imgBgColor
    },
    areas() {
      return this.module?.data?.areas || []
    }
  },
  methods: {
    onClickMap(record) {
      // redirectType 1: 跳转链接， 2: 商品详情, 11: 领券
      if (record.redirectType === "1") {
        this.$navigation.push(record.link.app)
      } else if (record.redirectType === "2") {
        this.$navigation.push(`${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${record.link}`)
      } else if (record.redirectType === "11") {
        this.getCoupon(record)
      }
    },
    /**
     * 获取优惠券
     */
    async getCoupon(param) {
      const { data } = await getPandoraCoupon({
        param: JSON.stringify({
          taskId: param.link,
          rewardItemId: param.rewardItemId
        })
      })
      const { code, customMessage } = data || {}
      if (code === "0000") {
        this.$message.success(customMessage)
      } else if (code === "1004") {
        // 已经领取过
        this.$message.error(customMessage)
      } else {
        this.$message.error(customMessage + "(" + code + ")")
      }
    },
    onLoadFinish(event) {
      const img = this.$el.querySelector(".el-image__inner")
      const width = img.naturalWidth
      const height = img.originalHeight
      let ratio = this.$el.clientWidth / width
      if (ratio > 1) {
        ratio = 1
      }

      this.module?.data?.areas.forEach(item => {
        const tempCoordsArr = item.coords.split(",")
        const _newCoords = []
        tempCoordsArr.forEach(cood => {
          _newCoords.push(parseFloat(cood) * ratio)
        })
        item.coords = _newCoords.toString()
      })
    },
    onLoadImageError() {
      this.isLoadErr = true
    },
    formatImgUrl
  }
}
